let backendHost;
let imageHost;
let sub_domain;
const hostname = window && window.location && window.location.hostname;

imageHost = 'https://app.orderanywhere.io';
sub_domain = window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:16000';
    imageHost = backendHost;

}else if(hostname==="192.168.1.11") {
    backendHost = 'http://192.168.1.11:16000';
    imageHost = backendHost;
}else{
    backendHost = 'https://'+hostname;
}
console.log(backendHost);
export const API_ROOT = `${backendHost}/webservices`;
export const IMAGE_ROOT = `${imageHost}`;
export const SUB_DOMAIN = `${sub_domain}`;
export const DOMAIN= `${hostname}`;


// WEBPACK FOOTER //
// ./src/api-config.js